var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('div',{attrs:{"id":"core-view"}},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1),(_vm.$route.name !== 'Maps')?_c('core-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }